'use client'

import { Button, Heading, Paragraph } from '@graftcode/design-system'

import { AUTH_LOGOUT_PATH } from '../../const/auth-logout-path.const'
import { useRefreshEmailVerification } from '../../hooks/useRefreshEmailVerification'

import styles from './EmailNotConfirmedPage.module.scss'

export function EmailNotConfirmedPage() {
  const { isChecking } = useRefreshEmailVerification()

  const handleLogout = () => {
    window.location.href = AUTH_LOGOUT_PATH
  }

  if (isChecking) {
    return (
      <main className={styles.page}>
        <div className={styles.spinner} />
      </main>
    )
  }

  return (
    <main className={styles.page}>
      <div className={styles.content}>
        <Heading type="h3">Confirm your email</Heading>
        <Paragraph size="l">
          Your account is signed in, but your email address is not confirmed yet. Please open your inbox and click the
          verification link, then return to this tab.
        </Paragraph>
        <div className={styles.action}>
          <Button size="l" variant="outlined" text="Logout" onClick={handleLogout} />
        </div>
      </div>
    </main>
  )
}
